import { Select, SelectProps } from "antd";
import { useDashboardYear, useYearRange } from "../../hooks/useDateRange";

export interface YearPickerProps extends SelectProps {}

export default function YearPicker(props: YearPickerProps) {
  const { data: years } = useYearRange();
  const { year, updateYear } = useDashboardYear();

  const onChange = (year: number) => {
    props?.onChange?.(year);
    updateYear(year);
  };

  return (
    <>
      <Select
        {...props}
        value={year}
        onChange={onChange}
        options={years?.map((x) => ({ value: x, label: x }))}
      />
    </>
  );
}
